import { Stack } from "@mui/material";
import { cn } from "utils/styling";

import type { RecordFormColumns, RecordFormField } from "./types";

import { DynamicFormFieldRenderer } from "./DynamicFormFieldRenderer";

type DynamicRecordFormGridProps = {
  columns?: RecordFormColumns;
  fields: RecordFormField[];
};

export const DynamicRecordFormGrid = ({ columns = 2, fields }: DynamicRecordFormGridProps) => {
  return (
    <div className={cn("w-full min-w-0", columns === 2 ? "grid w-full grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-4" : "flex w-full flex-col gap-4")}>
      {fields.map((field) => (
        <div
          className={cn("min-w-0 w-full", columns === 2 && (field.colSpan ?? 1) === 2 && "col-span-2")}
          key={field.filterName}
        >
          <DynamicFormFieldRenderer field={field} />
        </div>
      ))}
    </div>
  );
};

type DynamicRecordFormSectionsProps = {
  columns?: RecordFormColumns;
  sectionGroups: { fields: RecordFormField[]; section?: string }[];
};

export const DynamicRecordFormSections = ({ columns = 2, sectionGroups }: DynamicRecordFormSectionsProps) => {
  return (
    <Stack className="w-full min-w-0 flex-col gap-6">
      {sectionGroups.map((group, index) => (
        <Stack className="w-full flex-col gap-3" key={`${group.section ?? "default"}-${index}`}>
          {group.section && (
            <span className="uppercase tracking-wide text-lds-foreground-muted font-ds-body-semibold-sm">
              {group.section}
            </span>
          )}
          <DynamicRecordFormGrid columns={columns} fields={group.fields} />
        </Stack>
      ))}
    </Stack>
  );
};
